import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Id } from 'lesson-types';

interface UNIT_STATE_TYPE {
  id: Id | undefined;
  name?: string; // TODO: add to DB schema
}

const INITIAL_STATE: UNIT_STATE_TYPE = { id: '', name: '' };

const unitSlice = createSlice({
  name: 'unit',
  initialState: INITIAL_STATE,
  reducers: {
    setUnitId(state: UNIT_STATE_TYPE, action: PayloadAction<Id | undefined>) {
      state.id = action.payload;
    },
    setUnitName(state: UNIT_STATE_TYPE, action: PayloadAction<string>) {
      state.name = action.payload;
    },
    resetUnitState() {
      return INITIAL_STATE;
    },
  },
});

export const { setUnitId, setUnitName, resetUnitState } = unitSlice.actions;

export default unitSlice.reducer;
